    export const groupingIntervalsByInterval = {
        1000: [
            { name: "1 second", value: 1000 }
        ],
        5000: [
            { name: "1 second", value: 1000 },
            { name: "5 seconds", value: 5000 }
        ],
        10000: [
            { name: "1 second", value: 1000 },
            { name: "5 seconds", value: 5000 },
            { name: "10 seconds", value: 10000 }
        ],
        15000: [
            { name: "1 second", value: 1000 },
            { name: "5 seconds", value: 5000 },
            { name: "10 seconds", value: 10000 },
            { name: "15 seconds", value: 15000 }
        ],
        30000: [
            { name: "1 second", value: 1000 },
            { name: "5 seconds", value: 5000 },
            { name: "10 seconds", value: 10000 },
            { name: "15 seconds", value: 15000 },
            { name: "30 seconds", value: 30000 }
        ],
        60000: [
            { name: "1 second", value: 1000 },
            { name: "5 seconds", value: 5000 },
            { name: "10 seconds", value: 10000 },
            { name: "15 seconds", value: 15000 },
            { name: "30 seconds", value: 30000 },
            { name: "1 minute", value: 60000 }
        ],
        120000: [
            { name: "1 second", value: 1000 },
            { name: "5 seconds", value: 5000 },
            { name: "10 seconds", value: 10000 },
            { name: "15 seconds", value: 15000 },
            { name: "30 seconds", value: 30000 },
            { name: "1 minute", value: 60000 },
            { name: "2 minutes", value: 120000 }
        ],
        300000: [
            { name: "1 second", value: 1000 },
            { name: "5 seconds", value: 5000 },
            { name: "10 seconds", value: 10000 },
            { name: "15 seconds", value: 15000 },
            { name: "30 seconds", value: 30000 },
            { name: "1 minute", value: 60000 },
            { name: "2 minutes", value: 120000 },
            { name: "5 minutes", value: 300000 }
        ],
        450000: [
            { name: "5 seconds", value: 5000 },
            { name: "10 seconds", value: 10000 },
            { name: "15 seconds", value: 15000 },
            { name: "30 seconds", value: 30000 },
            { name: "1 minute", value: 60000 },
            { name: "2 minutes", value: 120000 },
            { name: "5 minutes", value: 300000 },
            { name: "10 minutes", value: 600000 }
        ],
        600000: [
            { name: "5 seconds", value: 5000 },
            { name: "10 seconds", value: 10000 },
            { name: "15 seconds", value: 15000 },
            { name: "30 seconds", value: 30000 },
            { name: "1 minute", value: 60000 },
            { name: "2 minutes", value: 120000 },
            { name: "5 minutes", value: 300000 },
            { name: "10 minutes", value: 600000 }
        ],
        900000: [
            { name: "5 seconds", value: 5000 },
            { name: "10 seconds", value: 10000 },
            { name: "15 seconds", value: 15000 },
            { name: "30 seconds", value: 30000 },
            { name: "1 minute", value: 60000 },
            { name: "2 minutes", value: 120000 },
            { name: "5 minutes", value: 300000 },
            { name: "10 minutes", value: 600000 },
            { name: "15 minutes", value: 900000 }
        ],
        1800000: [
            { name: "5 seconds", value: 5000 },
            { name: "10 seconds", value: 10000 },
            { name: "15 seconds", value: 15000 },
            { name: "30 seconds", value: 30000 },
            { name: "1 minute", value: 60000 },
            { name: "2 minutes", value: 120000 },
            { name: "5 minutes", value: 300000 },
            { name: "10 minutes", value: 600000 },
            { name: "15 minutes", value: 900000 },
            { name: "30 minutes", value: 1800000 }
        ],
        3600000: [
            { name: "10 seconds", value: 10000 },
            { name: "15 seconds", value: 15000 },
            { name: "30 seconds", value: 30000 },
            { name: "1 minute", value: 60000 },
            { name: "2 minutes", value: 120000 },
            { name: "5 minutes", value: 300000 },
            { name: "10 minutes", value: 600000 },
            { name: "15 minutes", value: 900000 },
            { name: "30 minutes", value: 1800000 },
            { name: "1 hour", value: 3600000 }
        ],
        7200000: [
            { name: "15 seconds", value: 15000 },
            { name: "30 seconds", value: 30000 },
            { name: "1 minute", value: 60000 },
            { name: "2 minutes", value: 120000 },
            { name: "5 minutes", value: 300000 },
            { name: "10 minutes", value: 600000 },
            { name: "15 minutes", value: 900000 },
            { name: "30 minutes", value: 1800000 },
            { name: "1 hour", value: 3600000 },
            { name: "2 hours", value: 7200000 }
        ],
        18000000: [
            { name: "1 minute", value: 60000 },
            { name: "2 minutes", value: 120000 },
            { name: "5 minutes", value: 300000 },
            { name: "10 minutes", value: 600000 },
            { name: "15 minutes", value: 900000 },
            { name: "30 minutes", value: 1800000 },
            { name: "1 hour", value: 3600000 },
            { name: "2 hours", value: 7200000 },
            { name: "5 hours", value: 18000000 }
        ],
        36000000: [
            { name: "2 minutes", value: 120000 },
            { name: "5 minutes", value: 300000 },
            { name: "10 minutes", value: 600000 },
            { name: "15 minutes", value: 900000 },
            { name: "30 minutes", value: 1800000 },
            { name: "1 hour", value: 3600000 },
            { name: "2 hours", value: 7200000 },
            { name: "5 hours", value: 18000000 },
            { name: "10 hours", value: 36000000 }
        ],
        43200000: [
            { name: "2 minutes", value: 120000 },
            { name: "5 minutes", value: 300000 },
            { name: "10 minutes", value: 600000 },
            { name: "15 minutes", value: 900000 },
            { name: "30 minutes", value: 1800000 },
            { name: "1 hour", value: 3600000 },
            { name: "2 hours", value: 7200000 },
            { name: "5 hours", value: 18000000 },
            { name: "10 hours", value: 36000000 },
            { name: "12 hours", value: 43200000 }
        ],
        86400000: [
            { name: "5 minutes", value: 300000 },
            { name: "10 minutes", value: 600000 },
            { name: "15 minutes", value: 900000 },
            { name: "30 minutes", value: 1800000 },
            { name: "1 hour", value: 3600000 },
            { name: "2 hours", value: 7200000 },
            { name: "5 hours", value: 18000000 },
            { name: "10 hours", value: 36000000 },
            { name: "12 hours", value: 43200000 },
            { name: "1 day", value: 86400000 }
        ],
        604800000: [
            { name: "30 minutes", value: 1800000 },
            { name: "1 hour", value: 3600000 },
            { name: "2 hours", value: 7200000 },
            { name: "5 hours", value: 18000000 },
            { name: "10 hours", value: 36000000 },
            { name: "12 hours", value: 43200000 },
            { name: "1 day", value: 86400000 },
            { name: "7 days", value: 604800000 }
        ],
        2592000000: [
            { name: "2 hours", value: 7200000 },
            { name: "5 hours", value: 18000000 },
            { name: "10 hours", value: 36000000 },
            { name: "12 hours", value: 43200000 },
            { name: "1 day", value: 86400000 },
            { name: "7 days", value: 604800000 },
            { name: "30 days", value: 2592000000 }
        ],
        3758400000: [
            { name: "5 hours", value: 18000000 },
            { name: "10 hours", value: 36000000 },
            { name: "12 hours", value: 43200000 },
            { name: "1 day", value: 86400000 },
            { name: "7 days", value: 604800000 },
            { name: "30 days", value: 2592000000 }
        ],
        8640000000: [
            { name: "10 hours", value: 36000000 },
            { name: "12 hours", value: 43200000 },
            { name: "1 day", value: 86400000 },
            { name: "7 days", value: 604800000 },
            { name: "30 days", value: 2592000000 }
        ],
        17712000000: [
            { name: "12 hours", value: 43200000 },
            { name: "1 day", value: 86400000 },
            { name: "7 days", value: 604800000 },
            { name: "30 days", value: 2592000000 }
        ],
        21600000000: [
            { name: "1 day", value: 86400000 },
            { name: "7 days", value: 604800000 },
            { name: "30 days", value: 2592000000 }
        ],
        51840000000: [
            { name: "7 days", value: 604800000 },
            { name: "30 days", value: 2592000000 }
        ]
    };